import { Tooltip } from '@repo/design-system/components/ui';
import FormToggleControls from "../../../forms/fieldsControl/FormToggleControls";

export const ToggleRenderer = (col, columnEvents = {}) => (rowData) => {
    const handler = columnEvents?.TOGGLE;
    const value = rowData?.[col.field];
    return (
        <>
            {/* 
               * Now, This Tooltip is commented. Because, Right now, We dont' need it.
               * If you want to use it, you can uncomment it. and below the TargetId also uncomment.
            */}
            <Tooltip label={!rowData[col.field] ? "Active" : "Inactive"}
                targetId={rowData[col.field] ? 'active' : 'inactive'} />
            <FormToggleControls
                targetId={rowData[col.field] ? 'active' : 'inactive'}
                dataField={col.field}
                name={col.field}
                value={value}
                onChange={(dataField, newValue) =>
                    handler?.(dataField, newValue, rowData)
                }
            // targetId={rowData.isActive ? 'active' : 'inactive'}
            />
        </>
    );
};